export default __webpack_public_path__ + "./fonts/4c112e110a336202365ba00324390d27.woff2";